import { makeStyles } from '@material-ui/styles';
import { inputColors } from '../../../../material-ui-kit/material-kit-pro-react';
import { alabasterDark, gainsboro, white } from '../../../../../constants/Colors';

export default makeStyles(() => ({
    root: {
        width: '100%',
        height: 'fit-content',
        marginLeft: '20px',
        backgroundColor: alabasterDark,
        border: `1px solid ${gainsboro}`,
        borderRadius: '3px',
        boxSizing: 'border-box',
    },
    editorHeader: {
        display: 'flex',
        alignItems: 'center',
        borderBottom: `1px solid ${gainsboro}`,
        boxSizing: 'border-box',
        padding: '15px 20px',
        width: '100%',
        justifyContent: 'space-between',
        height: '55px',
    },
    messageName: {
        width: '100%',
    },
    actionPanel: {
        flexShrink: '0',
    },
    saveButton: {
        padding: '5px 20px',
    },
    linkButton: {},
    textEditorContainer: {
        display: 'flex',
        margin: '0 50px',
        height: '100%',
        minHeight: '400px',
        pointerEvents: ({ readOnly }) => (readOnly ? 'none' : 'initial'),
    },
    emailSubjectAndBodyInput: {
        width: '100%',
        marginBottom: '-3px',
    },
    emailSubjectAndBodyInputSubject: {
        marginTop: '-1px',
        borderTopLeftRadius: '0',
        borderTopRightRadius: '0',
    },
    emailSubjectAndBodyInputBody: {
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0',
    },
    nameInput: {
        maxWidth: 450,
        width: '100%',
        cursor: 'pointer',
        background: 'none',
        fontSize: '17px',
        fontFamily: '"Source Sans Pro", Regular, sans-serif',
        border: '1px solid',
        borderColor: ({ nameFiledError }) => (nameFiledError ? inputColors.error.borderColor : 'transparent'),
        padding: '6px 0 7px 10px',
        borderRadius: '3px',
        outline: 'none',
        pointerEvents: ({ readOnly }) => (readOnly ? 'none' : 'initial'),
        '&:focus, &:active, &:hover': {
            cursor: 'text',
            backgroundColor: white,
            borderColor: ({ nameFiledError }) => (nameFiledError ? inputColors.error.borderColor : gainsboro),
        },
    },
}));
